/**
 * True when a contribution carries a settled reward the user still has to
 * claim in the app. `finalReward` is frozen at settlement and arrives as a
 * decimal string; empty, zero or non-numeric means there is nothing to claim.
 *
 * Admin cannot see whether the claim already happened — claim status lives on
 * the user side only — so this marks entitlement, not an outstanding balance.
 */
export function hasClaimablePoolReward(finalReward: string | null | undefined): boolean {
  const amount = Number(finalReward);
  return Number.isFinite(amount) && amount > 0;
}
